import React from 'react'
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import AvpHeader from '../shared/header/AvpHeader';
import AvpSaveFooter from '../shared/footer/AvpSaveFooter';
import BreadCrumb from '../shared/header/BreadCrumb';
import AvpGrafo from './AvpGrafo';
import AvpNodeSection from './AvpNodeSection';
import { userIsLogged, getRoute, apiGetAvpAssistenteById, apiGetAllSysLingue, apiGetAvpGrafo, apiGetAvpNodoTipoAvvio, apiPostAvpArcoAdd, apiPostAvpNodoAdd, apiDeleteAvpNodo, apiPostAvpNodoAvatar, apiGetAvpNodoDuplica } from "../shared/manager/api_manager";
import { useEffectOnce } from '../shared/manager/use_effect_once';
import { findNode, findStartNode } from './AvpGrafoUtil';
import { getValueByQueryString } from '../shared/manager/util';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';

export default function GestioneAvpGrafoScreen() {

  const navigate = useNavigate();

  const [avp, setAvp] = useState([]);
  const [avpGrafo, setAvpGrafo] = useState(null);
  const [avpLingue, setAvpLingue] = useState([]);
  const [allLingue, setAllLingue] = useState([]);
  const [selectedNode, setSelectedNode] = useState(null);
  const [tipoAvvioList, setTipoAvvioList] = useState([]);
  const [currentAvpLingua, setCurrentAvpLingua] = useState(null);

  const nodeSectionRef = React.useRef(null);

  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);



  const [breadCrumb, setBreadCrumb] = useState([
    { title: 'Gestione AVP', link: '/avp' },
    { title: 'Crea/Modifica AVP', link: null },
    { title: 'Grafo AVP', link: null },
  ]);

  const aggiungiBreadcrumb = (title, link) => {
    if (!breadCrumb.find((item) => item.title === title)) {
      setBreadCrumb([...breadCrumb, { title, link }]);
    }
  };


  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  useEffect(() => {
    console.log("RELOADDDDD", currentAvpLingua);

  }, [avpGrafo, selectedNode, currentAvpLingua])

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if(!route.funzioni.some(g => g.idFunzione === 20)) {
        navigate("/"); 
      }
      initPage();
    }
  }

  function stopPage() {
    console.log("stopPage");

  }

  function initPage() {
    console.log("initPage");

    loadLingue();
  }

  function loadLingue() {
    console.log("loadLingue");

    apiGetAllSysLingue(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAllLingue(response.data);
      }
      loadNodoTipoAvvio();
      loadAvp();
    });

  }

  function loadNodoTipoAvvio() {
    apiGetAvpNodoTipoAvvio(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setTipoAvvioList(response.data);
      }
    });
  }

  function loadAvp() {
    const url = window.location.pathname;
    const idAvp = url.substring(url.lastIndexOf('/') + 1);

    if (idAvp != null && idAvp != "") {
      apiGetAvpAssistenteById(idAvp, avpCallback);

    }
    else {
      setAvp(null);
    }
  }

  function setUpLingua(avp) {
    let requestedLingua = null;
    console.log("currentAvpLingua", currentAvpLingua);
    if (currentAvpLingua == null || currentAvpLingua == "undefined") {
      //check query param
      const queryIdLingua = getValueByQueryString("idlingua");
      if (queryIdLingua !== null && queryIdLingua !== "undefined" && queryIdLingua.length > 0) {
        if (avp.lingue != null && avp.lingue.length > 0) {
          for (var i = 0; i < avp.lingue.length; i++) {
            if (avp.lingue[i].idLingua == queryIdLingua) {
              requestedLingua = avp.lingue[i];
              break;
            }
          }
        }
      }

      if (requestedLingua == null) {
        //get default
        if (avp.lingue != null && avp.lingue.length > 0) {
          for (var i = 0; i < avp.lingue.length; i++) {
            if (avp.lingue[i].linguaDefault) {
              requestedLingua = avp.lingue[i];
              break;
            }
          }
        }
      }
      setCurrentAvpLingua(requestedLingua);
    }
    else {
      requestedLingua = currentAvpLingua;
    }

    console.log("requestedLingua", requestedLingua);
    return requestedLingua;
  }

  function avpCallback(response) {
    if (response != null && response.status >= 200 && response.status < 400) {
      console.log("AvpAssistente", response.data);
      aggiungiBreadcrumb(response.data.descAssistente, null)

      let lingua = setUpLingua(response.data);
      loadGrafo(response.data, lingua.idLingua);
    }
  }

  function loadGrafo(pAvp, idLingua) {

    if (pAvp != null) {

      setAvpLingue(pAvp.lingue);

      apiGetAvpGrafo(pAvp.idAvp, idLingua, function (response) {
        setAvp(pAvp);
        setAvpGrafo(response.data);

        console.log(" ---> avpGrafo", response.data);
        if (selectedNode != null) {
          //refresh
          let nodo = findNode(selectedNode.idNodo, response.data.nodi);
          if (nodo != null) {
            setSelectedNode(nodo);
            console.log("selected node: ", nodo);
          }
          else {
            loadNodoFromScratch(response.data.nodi);
          }
        }
        else {
          loadNodoFromScratch(response.data.nodi);
        }

      });
    }
  }

  function loadNodoFromScratch(nodi) {

    let pIdNodo = getValueByQueryString("idnodo");
    let nodo = null;
    if (pIdNodo != null && pIdNodo != "") {
      nodo = findNode(eval(pIdNodo), nodi);
      if (nodo != null) {
        setSelectedNode(nodo);
        console.log("selected node from query: ", nodo);
      }
    }

    if (nodo == null) {
      nodo = findStartNode(nodi);
      if (nodo != null) {
        setSelectedNode(nodo);
        console.log("selected start node: ", nodo);
      }
      else {
        console.warn("start node not found... in", nodi);
        setSelectedNode(null);
      }
    }

  }

  function footerCancelCallback() {
    console.log("cancel");
    navigate("/avp/" + avp.idAvp);
  }

  function footerSaveCallback() {
    console.log("save");
    grafoNodeSave();
  }

  function grafoNodeSave() {
    let nodeData;

    if (nodeSectionRef.current!=null && nodeSectionRef.current.getData) {
      nodeData = nodeSectionRef.current.getData();
      console.log("FORM nodeData -> ", nodeData);
    }


    if (nodeData && nodeData.props) {
      if (nodeData.props != null) {
        selectedNode.tipoAvvio = nodeData.props.tipoAvvio;
        selectedNode.descNodo = nodeData.props.descNodo;
        selectedNode.apiEsterna = nodeData.props.apiEsterna;
        selectedNode.flagGoBack = nodeData.props.flagGoBack;
        selectedNode.pipAvatarX = nodeData.props.pipAvatarX;
        selectedNode.pipAvatarY = nodeData.props.pipAvatarY;
        selectedNode.pipAvatarW = nodeData.props.pipAvatarW;
        selectedNode.pipAvatarH = nodeData.props.pipAvatarH;
        selectedNode.pipAvatarZ = nodeData.props.pipAvatarZ;
        selectedNode.pipContentsX = nodeData.props.pipContentsX;
        selectedNode.pipContentsY = nodeData.props.pipContentsY;
        selectedNode.pipContentsW = nodeData.props.pipContentsW;
        selectedNode.pipContentsH = nodeData.props.pipContentsH;
        selectedNode.pipContentsZ = nodeData.props.pipContentsZ;
      }
      selectedNode.sysUser = "";
      selectedNode.sysDate = new Date().toISOString();
      selectedNode.sysAttivo = true;

      const { children, ...filteredSelectedNode } = selectedNode;

      console.log("SAVE selectedNode -> ", filteredSelectedNode);
      //save nodo
      apiPostAvpNodoAdd(filteredSelectedNode, function (response) {
        if (response != null && response.status >= 200 && response.status < 400) {
          //check avatar
          if (nodeData.avatar != null) {
            const avatar = {
              idNodo: selectedNode.idNodo,
              idLingua: nodeData.avatar.idLingua,
              idFile: nodeData.avatar.idFile,
              tipoAvatar: nodeData.avatar.tipoAvatar,
              formato: "",
              speechText: ""
            };
            apiPostAvpNodoAvatar(avatar, function (avatarResponse) {
              if (avatarResponse != null && avatarResponse.status >= 200 && avatarResponse.status < 400) {
                setAlertSuccessOpen(true);
                setAlertErrorOpen(false);
                initPage();
              }
              else {
                setAlertSuccessOpen(false);
                setAlertErrorOpen(true);
              }

            });
          }
          else {
            setAlertSuccessOpen(true);
            setAlertErrorOpen(false);
            initPage();
          }
        }
      });

    }

  }

  function grafoAddCallback() {
    console.log("grafoAdd", selectedNode);
    if (selectedNode != null) {
      let tmpNode = {
        idAvp: avp.idAvp,
        descNodo: "nuovo",
        nodoStart: false,
        tipoAvvio: 1,
        apiEsterna: "",
        formato: "",
        flagGoBack: false,
        sysUser: "",
        sysDate: new Date().toISOString(),
        sysAttivo: true
      };
      apiPostAvpNodoAdd(tmpNode, function (response) {
        if (response != null && response.status >= 200 && response.status < 400) {
          let newNode = response.data;
          if (newNode != null) {
            let tmpArco = {
              formato: "",
              idLingua: (avp.lingue != null && avp.lingue.length > 0 ? avp.lingue[0].idLingua : null),
              idNodoStart: selectedNode.idNodo,
              idNodoEnd: newNode.idNodo,
              ordine: 1,
              testo: "nuovo arco",
            };
            apiPostAvpArcoAdd(tmpArco, function (response) {
              if (response != null && response.status >= 200 && response.status < 400) {
                loadGrafo(avp, currentAvpLingua.idLingua);
              }
            });
          }
        }
      });
    }
  }

  function grafoDeleteCallback() {
    console.log("grafoDelete", selectedNode);
    if (selectedNode != null) {
      apiDeleteAvpNodo(selectedNode.idNodo, function (response) {
        if (response != null && response.status >= 200 && response.status < 400) {
          loadGrafo(avp, currentAvpLingua.idLingua);
        }
      });
    }
  }

  function grafoDuplicateCallback() {
    console.log("grafoDuplicate", selectedNode);
    if (selectedNode != null) {
      apiGetAvpNodoDuplica(selectedNode.idNodo, function (response) {
        if (response != null && response.status >= 200 && response.status < 400) {
          loadGrafo(avp, currentAvpLingua.idLingua);
        }
      });
    }
  }

  function grafoSelectedCallback(node) {
    if (selectedNode != node) {
      setSelectedNode(node);
    }
  }

  function grafoArcoSelectedCallback(arc) {
    let idLingua = currentAvpLingua.idLingua;
    navigate("/avp/grafo/nodo/arco?action=edit&idavp=" + avp.idAvp + "&idnodo=" + arc.idNodo + "&idarco=" + arc.idArco + "&idlingua=" + idLingua);
  }

  function handleNodeActionCallback(action, idNodo, idArco) {
    console.log("nodeAction: " + action + "  idNodo: " + idNodo + "   idArco: " + idArco);
    if (action == "changeLang") {
      let lingua = null;
      if (avpLingue != null && avpLingue.length > 0) {
        for (var i = 0; i < avpLingue.length; i++) {
          if (avpLingue[i].idLingua == idNodo) {
            lingua = avpLingue[i];

            break;
          }
        }
      }
      console.log("changeLang", lingua);
      setCurrentAvpLingua(lingua);
      loadGrafo(avp, lingua.idLingua);

    }
    else {
      loadGrafo(avp, currentAvpLingua.idLingua);
    }

    //
  }

  return (
    <div id="avp-gestioneavp-screen"  >
      <AvpHeader selectedMenuId={"avp"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#modificagrafo"} />
      <div id="avp-cms-screen-container"  >
        <div className="avp-cms-screen-content avp-cms-screen-content-grafocontent"  >
          <Collapse in={alertSuccessOpen} timeout={{ enter: 1000, exit: 1000 }} addEndListener={() => { setTimeout(() => { setAlertSuccessOpen(false) }, 2000); }}>
            <Alert variant="filled" severity="success" onClose={() => { setAlertSuccessOpen(false) }}>
              Modifica effettuata con successo.
            </Alert>
          </Collapse>
          <Collapse in={alertErrorOpen}>
            <Alert variant="filled" severity="error" onClose={() => { setAlertErrorOpen(false) }}>
              Si è verificato un errore durante la modifica...
            </Alert>
          </Collapse>
          <div className="avp-cms-screen-content-grafoleft"  >
            <div className="avp-cms-screen-content-row clearfix" style={{ "color": "#000000", "fontSize": "24px", "fontWeight": "600" }}>
              {selectedNode != null ? selectedNode.nodoStart ? 'START' : selectedNode.descNodo : ''}
              &nbsp;&nbsp;<span style={{ "color": "#000000", "fontSize": "16px", "fontWeight": "300" }} >{selectedNode != null ? '(ID: ' + selectedNode.idNodo + ")" : ''}</span>
            </div>
            <AvpNodeSection ref={nodeSectionRef} avp={avpGrafo} node={selectedNode} tipiAvvio={tipoAvvioList} avpAssistente={avp} lingue={avpLingue} currentLingua={currentAvpLingua} nodeActionCallback={handleNodeActionCallback} />
          </div>
          <div className="avp-cms-screen-content-graforight"  >
            <AvpGrafo data={avpGrafo} pNode={selectedNode} addCallback={grafoAddCallback} deleteCallback={grafoDeleteCallback} duplicateCallback={grafoDuplicateCallback} selectedCallback={grafoSelectedCallback} arcCallback={grafoArcoSelectedCallback} ></AvpGrafo>
          </div>
        </div>
      </div>
      <AvpSaveFooter saveCallback={footerSaveCallback} cancelCallback={footerCancelCallback} />
    </div>
  );

} 